document.addEventListener("DOMContentLoaded", function() {
  const navbar = document.querySelector('header');
  const menuDrawer = document.getElementById('MenuDrawer') || document.querySelector('menu-drawer');
  const searchBar = document.querySelector('.header__search');
  
  let lastScrollTop = 0;
  const threshold = 120;
  const tolerance = 15;

  if (navbar) {
    navbar.style.transition = 'transform 0.3s ease-in-out';
  }

  window.addEventListener('scroll', function() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollDistance = Math.abs(scrollTop - lastScrollTop);

    if (window.innerWidth <= 767) {
      const isMenuOpen = menuDrawer && (menuDrawer.hasAttribute('open') || menuDrawer.classList.contains('active'));
      const isSearchOpen = searchBar && searchBar.classList.contains('is-active');

      if (isMenuOpen || isSearchOpen || scrollTop < threshold) {
        navbar.style.transform = "translateY(0)";
        document.body.classList.remove('is-header-hidden');
      } 
      else {
        if (scrollTop > lastScrollTop && scrollTop > threshold) {
          navbar.style.transform = "translateY(-100%)";
          document.body.classList.add('is-header-hidden');
        } 
        else if (scrollTop < lastScrollTop && scrollDistance > tolerance) {
          navbar.style.transform = "translateY(0)";
          document.body.classList.remove('is-header-hidden');
        }
      }
    } else {
      navbar.style.transform = "translateY(0)";
      document.body.classList.remove('is-header-hidden');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }, { passive: true });
});